module.exports = __webpack_public_path__ + "static/media/Logout.b1b61dfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Logout.svg
// module id = 1152
// module chunks = 0